import React, { useEffect, useState } from 'react';
import { Container, Alert, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createRoom, getUserActiveRoomCount } from '../services/api';
import { useNotification } from '../contexts/NotificationContext';
import RoomForm from '../components/room/RoomForm';
import { event as gaEvent } from '../utils/analytics';

function CreateListing() {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const [roomCount, setRoomCount] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkRoomCount = async () => {
            try {
                const response = await getUserActiveRoomCount();
                setRoomCount(response.count);
                if (response.canCreate) {
                    gaEvent({ category: 'conversion', action: 'room_listing_started' });
                }
                if (!response.canCreate) {
                    showNotification('物件の登録数が上限（3件）に達しています。新しい物件を登録するには、既存の物件を非公開にするか削除してください。', 'warning');
                    navigate('/my-rooms', {
                        state: {
                            message: '物件の登録数が上限に達しています。既存の物件を非公開にするか削除してから、新しい物件を登録してください。',
                            severity: 'warning'
                        }
                    });
                }
            } catch (error) {
                console.error('物件数取得エラー:', error);
                showNotification('物件情報の取得に失敗しました', 'error');
            } finally {
                setLoading(false);
            }
        };

        checkRoomCount();
    }, [showNotification, navigate]);

    const handleSubmit = async (formData) => {
        try {
            await createRoom(formData);
            gaEvent({ category: 'conversion', action: 'room_listing_completed' });
            showNotification('物件を登録しました', 'success');
            navigate('/my-rooms');
        } catch (error) {
            console.error('登録エラー詳細:', error);

            if (error.response?.data?.error === 'LISTING_LIMIT_EXCEEDED') {
                showNotification('物件の登録数が上限（3件）に達しています', 'error');
            } else if (error.response?.data?.error === 'VALIDATION_ERROR') {
                const errorData = error.response.data;
                if (errorData.missingFields) {
                    showNotification(`必須フィールドが不足しています: ${errorData.missingFields.join(', ')}`, 'error');
                } else if (errorData.validationErrors) {
                    const errorMessages = errorData.validationErrors.map(err => err.message).join(', ');
                    showNotification(`入力エラー: ${errorMessages}`, 'error');
                } else {
                    showNotification(errorData.message || 'バリデーションエラーが発生しました', 'error');
                }
            } else {
                showNotification(
                    error.response?.data?.message || '物件の登録に失敗しました',
                    'error'
                );
            }
        }
    };

    if (loading) {
        return <Container>読み込み中...</Container>;
    }

    return (
        <Container>
            {roomCount >= 3 && (
                <Box mb={3}>
                    <Alert severity="warning">
                        現在{roomCount}件の物件が公開中です。新しい物件を登録するには、既存の物件を非公開にするか削除してください。
                    </Alert>
                </Box>
            )}
            <RoomForm onSubmit={handleSubmit} disabled={roomCount >= 3} />
        </Container>
    );
}

export default CreateListing; 